import { useCallback, useLayoutEffect, useRef, useState } from 'react';
import FeedCardSkeleton from 'app/shared/modules/FeedCard/FeedCardSkeleton';
import ChevronUp from 'app/shared/modules/ViewModeToggle/ChevronUp';
import { ChevronLeftIcon, ListIcon } from 'app/shared/halo/components/ui/icons';
import { Button } from 'app/shared/halo/components/ui/Button';
import { useViewMode } from 'app/shared/hooks/useViewMode';
import { openShortlistSheet } from 'app/shared/halo/stores/shortlistSheetStore';
import ChevronDown from './ChevronDown';
import {
  backToListButton,
  backToListChevron,
  feedContainer,
  feedCounterText,
  feedHeader,
  feedHeaderRow,
  feedScroller,
  feedSlide,
  navButton,
  navIcon,
  rightRail,
} from './feedView.styles';

const SKELETON_COUNT = 3;
const MD_BREAKPOINT = 768;

const FeedSkeletonView = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [feedHeight, setFeedHeight] = useState<string | null>(null);
  const [, setViewMode] = useViewMode();

  useLayoutEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const updateHeight = () => {
      if (window.innerWidth < MD_BREAKPOINT) {
        setFeedHeight(null);
        return;
      }
      const rect = container.getBoundingClientRect();
      setFeedHeight(`calc(100vh - ${Math.round(rect.top)}px)`);
    };

    updateHeight();
    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  const handleBackToList = useCallback(() => {
    setViewMode('grid');
  }, [setViewMode]);

  return (
    <div
      ref={containerRef}
      className={feedContainer}
      style={feedHeight ? { height: feedHeight } : undefined}
      aria-label="Loading listings"
      role="status"
    >
      <div className={feedHeader}>
        <div className={feedHeaderRow}>
          <button type="button" className={backToListButton} onClick={handleBackToList}>
            <span className={backToListChevron}>
              <ChevronLeftIcon />
            </span>
            Back to list
          </button>
          <Button
            shape="circle"
            tone="neutral"
            emphasis="outlined"
            size="md"
            onClick={openShortlistSheet}
            aria-label="View saved listings"
          >
            <ListIcon />
          </Button>
        </div>
        <p className={feedCounterText}>Loading...</p>
      </div>

      <div className={feedScroller} style={{ overflowY: 'hidden' }}>
        {Array.from({ length: SKELETON_COUNT }, (_, i) => (
          <div key={i} className={feedSlide}>
            <FeedCardSkeleton />
          </div>
        ))}
      </div>

      <div className={rightRail}>
        <button type="button" className={navButton} disabled aria-hidden="true">
          <ChevronUp className={navIcon} />
        </button>
        <button type="button" className={navButton} disabled aria-hidden="true">
          <ChevronDown className={navIcon} />
        </button>
      </div>
    </div>
  );
};

export default FeedSkeletonView;
